
const teachingTeamRouter = [
  {
    path: '/teachingTeam',
    name: 'TeachingTeam',
    meta: {
      title: '讲师团队'
    },
    component: () => import('@/views/teachingTeam/index.vue'),
  },
  {
    path: '/teachingInfo',
    name: 'TeachingInfo',
    component: () =>
        import('@/views/teachingTeam/detail.vue'),
    meta: {
      title: '讲师详情'
    }
  },
  {
    path: '/teacherRegistinfo',
    name: 'TeacherRegistinfo',
    meta: {
      title: '注册信息',
      type: 'login'
    },
    component: () => import('@/views/mine/homepage/teacherRegistInfo.vue')
  }
]
export default teachingTeamRouter
